import React, {useState, useEffect, useContext} from "react";
import { AuthContext } from "../../context/Auth";
import { useNavigate } from "react-router-dom";
import { FaRegTrashAlt, FaRegEye, FaEdit } from "react-icons/fa";
import { MdOutlineOpenInNew } from "react-icons/md";
import { createAdminUser, deleteAdminUser, getAllAdminUsers, updateSubscription } from "../../business/AdminBusiness";
import { CiCircleRemove } from "react-icons/ci";
import { deleteUser, getAllUsers } from "../../business/UserBusiness";
import toast from "react-hot-toast";
import { Sidebar } from '../../components/Sidebar';

export const Collaborator = () => {

    const [name, setName] = useState('');
    const [password, setPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [role, setRole] = useState('admin');
    const navigate = useNavigate()
    const [users, setUsers] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [addAdmin, setAddAdmin] = useState(null);
    const [selectedDelete, setSelectedDelete] = useState(null)
    const [selectedPerson, setSelectedPerson] = useState(null)
    const [selectedDeleteUser, setSelectedDeleteUser] = useState(null)
    const [selectedUserId, setSelectedUserId] = useState(null)
    const [sortBy, setSortBy] = useState('createdAt'); // 'createdAt' ou 'username'
    const [sortOrder, setSortOrder] = useState('desc'); // 'asc' ou 'desc'
    const [showTransactions, setShowTransactions] = useState(false);
  
    const adminName = localStorage.getItem("@Auth:name")
    const idLocal = localStorage.getItem("@Auth:Id")

    const id = idLocal?.split('"')?.join('')
  
    const fetchUsers = async () => {
      try {
        setIsLoading(true);
        // Buscar todos os usuários e filtrar apenas admins
        const response = await getAllUsers();
        console.log(response);
        const allUsers = response?.data || [];
        const adminUsers = allUsers.filter(user => user?.role === 'admin');
        setUsers(adminUsers);
        setIsLoading(false);
      } catch (err) {
        console.log(err);
      }
    };
  
  const confirmDeleteUser = async (userId) => {
    try {
        await deleteUser(userId);      
        toast.success('Administrador removido com sucesso!');
        setSelectedPerson(null)
        fetchUsers(); // Recarregar lista
  
    } catch (error) {
        console.error('Erro ao excluir administrador:', error);
        toast.error('Erro ao deletar administrador')
    }
  
  };
  
    const filteredUsers = users?.filter((user) => 
      user?.username?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      user?.email?.toLowerCase().includes(searchTerm?.toLowerCase())
    )

    // Ordenar usuários
    const sortedUsers = filteredUsers?.sort((a, b) => {
      if (sortBy === 'username') {
        const nameA = a.username?.toLowerCase() || '';
        const nameB = b.username?.toLowerCase() || '';
        return sortOrder === 'asc' ? nameA.localeCompare(nameB) : nameB.localeCompare(nameA);
      } else if (sortBy === 'createdAt') {
        const dateA = new Date(a.createdAt || 0);
        const dateB = new Date(b.createdAt || 0);
        return sortOrder === 'asc' ? dateA - dateB : dateB - dateA;
      }
      return 0;
    });
  
    const handleSearchTerm = (e) => {
      setSearchTerm(e.target.value);
    };

    const handleSortChange = (newSortBy) => {
      if (sortBy === newSortBy) {
        setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
      } else {
        setSortBy(newSortBy);
        setSortOrder('desc'); // Sempre começar pelo mais recente
      }
    };
  
    const handlePersonClick = (person) => {
      setSelectedPerson(person);
      setSelectedUserId(person?._id);
      setShowTransactions(true);
    };
  
    const handleModalClose = () => {
      setSelectedPerson(null);
      setShowTransactions(false);
    };

    const handleEditClick = (e, person) => {
      e.stopPropagation();
      // Implementar lógica de edição aqui
      console.log('Editar usuário:', person);
    };
  
    const formatCreatedAt = (createdAt) => {
      const createdAtDate = new Date(createdAt);
      return createdAtDate.toLocaleDateString("pt-BR", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    };

    const formatTransactionDate = (date) => {
      const transactionDate = new Date(date);
      return transactionDate.toLocaleDateString("pt-BR", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
      });
    };

    const formatCurrency = (amount) => {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(amount / 100); // Assumindo que o valor vem em centavos
    };

    // Função para gerar iniciais do username
    const getInitials = (username) => {
      if (!username) return '?';
      const names = username.trim().split(' ');
      if (names.length === 1) {
        return names[0].charAt(0).toUpperCase();
      }
      return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
    };

    // Função para gerar cor baseada no username
    const getAvatarColor = (username) => {
      if (!username) return 'bg-gray-500';
      const colors = [
        'bg-red-500',
        'bg-blue-500', 
        'bg-green-500',
        'bg-yellow-500',
        'bg-purple-500',
        'bg-pink-500',
        'bg-indigo-500',
        'bg-teal-500'
      ];
      const index = username.charCodeAt(0) % colors.length;
      return colors[index];
    };
  
  
    useEffect(() => {
      fetchUsers();
    }, []);

    const handleAddAdmin = async () => {
        try{
            if (!name || !email || !phone || !password) {
                toast.error('Por favor, preencha todos os campos obrigatórios');
                return;
            }

            if (password !== repeatPassword) {
                toast.error('As senhas não coincidem');
                return;
            }

            const admin = {
                username: name,
                email: email,
                phone: phone,
                password: password,
                role: role
            }
            
            setIsLoading(true)

            await createAdminUser(admin)

            toast.success('Administrador criado com sucesso!')
            
            setIsLoading(false)
            
            setAddAdmin(false)
            
            // Limpar campos
            setName('');
            setEmail('');
            setPhone('');
            setPassword('');
            setRepeatPassword('');
            
            // Recarregar lista
            fetchUsers();
        } catch (err) {
            console.log(err)
            toast.error(err?.response?.data?.msg || 'Erro ao criar administrador')
        }
    }

    const { user } = useContext(AuthContext);

    return(
        <>
            <div className="flex flex-col lg:flex-row">
                <Sidebar />
                <div className="flex-1 min-h-screen bg-white">
                    <div className="max-w-7xl w-full mx-auto py-6 px-2 sm:px-4">
                        {/* Cabeçalho e filtros */}
                        <div className="mb-4">
                            <h1 className="text-lg lg:text-xl font-light leading-6">Olá, <span className="font-bold">{adminName}</span></h1>
                            <p className="text-base lg:text-lg font-light leading-6 text-gray-700">Colaboradores - Apenas Administradores</p>
                        </div>
                        {/* Filtros e busca */}
                        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-4 space-y-4 lg:space-y-0">
                            <label
                                htmlFor="name"
                                className="block text-sm font-medium leading-6 text-gray-900"
                            >
                                Pesquise por username ou email ({sortedUsers?.length || 0} administradores)
                            </label>
                            <div className="flex flex-col lg:flex-row items-start lg:items-center space-y-2 lg:space-y-0 lg:space-x-4 w-full lg:w-auto">
                                <button
                                    onClick={() => setAddAdmin(true)}
                                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded w-full lg:w-auto"
                                >
                                    Adicionar administrador
                                </button>
                            </div>
                        </div>
                        <div className="relative mt-2 rounded-md shadow-sm">
                            <input
                                type="text"
                                name="name"
                                id="name"
                                className="block w-full rounded-md border-0 py-1.5 pl-7 pr-20 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                placeholder="Digite um username ou email..."
                                onChange={handleSearchTerm}
                                value={searchTerm}
                            />
                        </div>

                        {/* Tabela responsiva */}
                        <div className="overflow-x-auto">
                            <table className="divide-y divide-gray-100 w-full">
                                <thead>
                                    <tr className="bg-gray-100">
                                        <th 
                                            className="px-3 lg:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-200 transition-colors"
                                            onClick={() => handleSortChange('username')}
                                        >
                                            <div className="flex items-center">
                                                Username
                                                {sortBy === 'username' && (
                                                    <span className="ml-1 text-gray-400">
                                                        {sortOrder === 'asc' ? '↑' : '↓'}
                                                    </span>
                                                )}
                                            </div>
                                        </th>
                                        <th className="px-3 lg:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider hidden md:table-cell">Email</th>
                                        <th className="px-3 lg:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider hidden lg:table-cell">Telefone</th>
                                        <th className="px-3 lg:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Role</th>
                                        <th className="px-3 lg:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider hidden lg:table-cell">Premium</th>
                                        <th 
                                            className="px-3 lg:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider hidden xl:table-cell cursor-pointer hover:bg-gray-200 transition-colors"
                                            onClick={() => handleSortChange('createdAt')}
                                        >
                                            <div className="flex items-center">
                                                Criado em
                                                {sortBy === 'createdAt' && (
                                                    <span className="ml-1 text-gray-400">
                                                        {sortOrder === 'asc' ? '↑' : '↓'}
                                                    </span>
                                                )}
                                            </div>
                                        </th>
                                        <th className="px-3 lg:px-6 py-3"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isLoading ? (
                                        <tr>
                                            <td colSpan="7" className="py-4 px-6 text-center">Carregando...</td>
                                        </tr>
                                    ) : (

                                        sortedUsers && sortedUsers.length > 0 ? (
                                        sortedUsers?.map((person) => (
                                            <tr
                                                key={person?.email}
                                                className="hover:bg-gray-100 cursor-pointer"
                                                onClick={() => handlePersonClick(person)}
                                            >
                                                <td className="px-3 lg:px-6 py-4 whitespace-nowrap">
                                                    <div className="flex items-center">
                                                        <div className="flex-shrink-0 h-8 w-8 lg:h-12 lg:w-12">
                                                            <div className={`h-8 w-8 lg:h-12 lg:w-12 rounded-full flex items-center justify-center text-white font-semibold text-sm lg:text-lg ${getAvatarColor(person?.username)}`}>
                                                                {getInitials(person?.username)}
                                                            </div>
                                                        </div>
                                                        <div className="ml-2 lg:ml-4">
                                                            <div className="text-xs lg:text-sm font-medium text-gray-900 truncate max-w-[120px] lg:max-w-none">{person?.username}</div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="px-3 lg:px-6 py-4 whitespace-nowrap hidden md:table-cell">
                                                    <div className="text-xs lg:text-sm text-gray-900 truncate max-w-[150px]">{person?.email}</div>
                                                </td>
                                                <td className="px-3 lg:px-6 py-4 whitespace-nowrap hidden lg:table-cell">
                                                    <div className="text-xs lg:text-sm text-gray-900">{person?.phone}</div>
                                                </td>
                                                <td className="px-3 lg:px-6 py-4 whitespace-nowrap">
                                                    <span className={`inline-flex items-center px-2 py-0.5 lg:px-2.5 lg:py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800`}>
                                                        Administrador
                                                    </span>
                                                </td>
                                                <td className="px-3 lg:px-6 py-4 whitespace-nowrap text-xs lg:text-sm text-gray-500 hidden lg:table-cell">{person?.subscription === 'active' ? 'Sim' : 'Não'}</td>
                                                <td className="px-3 lg:px-6 py-4 whitespace-nowrap text-xs lg:text-sm text-gray-500 hidden xl:table-cell">{formatCreatedAt(person?.createdAt)}</td>
                                                <td className="px-3 lg:px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                                    <div className="flex items-center space-x-1 lg:space-x-2">
                                                        <div
                                                            className={`text-gray-900 ${person.email === 'alexandresaintss@gmail.com' && user?.email !== 'alexandresaintss@gmail.com' ? 'opacity-50 cursor-not-allowed' : 'hover:text-indigo-600 cursor-pointer'}`}
                                                            onClick={person.email === 'alexandresaintss@gmail.com' && user?.email !== 'alexandresaintss@gmail.com' ? undefined : (e) => handleEditClick(e, person)}
                                                            title={person.email === 'alexandresaintss@gmail.com' && user?.email !== 'alexandresaintss@gmail.com' ? 'Somente o próprio Alexandre pode editar' : 'Editar'}
                                                        >
                                                            <FaEdit size={14} className="lg:w-4 lg:h-4" color="blue"/>
                                                        </div>
                                                        <div
                                                            className={`text-gray-900 ${person.email === 'alexandresaintss@gmail.com' && user?.email !== 'alexandresaintss@gmail.com' ? 'opacity-50 cursor-not-allowed' : 'hover:text-indigo-600 cursor-pointer'}`}
                                                            onClick={person.email === 'alexandresaintss@gmail.com' && user?.email !== 'alexandresaintss@gmail.com' ? undefined : () => {
                                                                if (window.confirm('Tem certeza que deseja excluir este administrador?')) {
                                                                    confirmDeleteUser(person?._id);
                                                                }
                                                            }}
                                                            title={person.email === 'alexandresaintss@gmail.com' && user?.email !== 'alexandresaintss@gmail.com' ? 'Somente o próprio Alexandre pode excluir' : 'Excluir'}
                                                        >
                                                            <FaRegTrashAlt size={14} className="lg:w-4 lg:h-4" color="red"/>
                                                        </div>
                                                        <div className="text-gray-900 hover:text-indigo-600 cursor-pointer">
                                                            <FaRegEye size={14} className="lg:w-4 lg:h-4" color="grey-500"/>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                        ) : (
                                        <tr>
                                            <td colSpan="7" className="py-4 px-6 text-center">Nenhum administrador encontrado</td>
                                        </tr>
                                        )
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {addAdmin && (
                <div className="fixed top-0 left-0 w-full h-full bg-gray-900 bg-opacity-75 flex justify-center items-center">
                    <div className="bg-white p-8 rounded-lg w-96">
                        <div className="flex justify-between items-center mb-6">
                            <h2 className="text-xl font-semibold">Adicionar Administrador</h2>
                            <button
                                onClick={() => setAddAdmin(false)}
                                className="text-gray-500 hover:text-gray-700"
                            >
                                ✕
                            </button>
                        </div>
                        
                        <div className="mb-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="name">
                                Nome
                            </label>
                            <input 
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" 
                                id="name" 
                                type="text" 
                                placeholder="Nome completo" 
                                onChange={(e) => setName(e.target.value)}
                                value={name}
                            />
                        </div>
                        
                        <div className="mb-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">
                                Email
                            </label>
                            <input 
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" 
                                id="email" 
                                type="email" 
                                placeholder="email@exemplo.com" 
                                onChange={(e) => setEmail(e.target.value)}
                                value={email}
                            />
                        </div>
                        
                        <div className="mb-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="phone">
                                Telefone
                            </label>
                            <input 
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" 
                                id="phone" 
                                type="tel" 
                                placeholder="(11) 99999-9999" 
                                onChange={(e) => setPhone(e.target.value)}
                                value={phone}
                            />
                        </div>
                        
                        <div className="mb-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="password">
                                Senha
                            </label>
                            <input 
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" 
                                id="password" 
                                type="password" 
                                placeholder="******************" 
                                onChange={(e) => setPassword(e.target.value)}
                                value={password}
                            />
                        </div>
                        
                        <div className="mb-6">
                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="repeatPassword">
                                Repetir senha
                            </label>
                            <input 
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" 
                                id="repeatPassword" 
                                type="password" 
                                placeholder="******************" 
                                onChange={(e) => setRepeatPassword(e.target.value)}
                                value={repeatPassword}
                            />
                        </div>
                        
                        <div className="flex items-center justify-between">
                            <button 
                                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
                                onClick={handleAddAdmin}
                                disabled={isLoading}
                            >
                                {isLoading ? 'Criando...' : 'Criar Administrador'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de detalhes do usuário com transações */}
            {selectedPerson && showTransactions && (
                <div className="fixed top-0 left-0 w-full h-full bg-gray-900 bg-opacity-75 flex justify-center items-center p-4">
                    <div className="bg-white p-8 rounded-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto">
                        <div className="flex justify-between items-center mb-6">
                            <h2 className="text-xl font-semibold">Detalhes do Administrador</h2>
                            <button
                                onClick={handleModalClose}
                                className="text-gray-500 hover:text-gray-700"
                            >
                                ✕
                            </button>
                        </div>
                        
                        <div className="flex items-center mb-6">
                            <div className={`h-16 w-16 rounded-full flex items-center justify-center text-white font-semibold text-2xl ${getAvatarColor(selectedPerson?.username)}`}>
                                {getInitials(selectedPerson?.username)}
                            </div>
                            <div className="ml-4">
                                <h3 className="text-lg font-semibold">{selectedPerson?.username}</h3>
                                <p className="text-gray-600">{selectedPerson?.email}</p>
                            </div>
                        </div>
                        
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                            <div className="mb-4">
                                <label className="block text-gray-700 text-sm font-bold mb-1">Telefone:</label>
                                <p className="text-gray-900">{selectedPerson?.phone}</p>
                            </div>
                            
                            <div className="mb-4">
                                <label className="block text-gray-700 text-sm font-bold mb-1">Cargo:</label>
                                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                                    Administrador
                                </span>
                            </div>
                            
                            <div className="mb-4">
                                <label className="block text-gray-700 text-sm font-bold mb-1">Criado em:</label>
                                <p className="text-gray-900">{formatCreatedAt(selectedPerson?.createdAt)}</p>
                            </div>
                        </div>

                        {/* Seção de Transações */}
                        <div className="mt-8">
                            <h3 className="text-lg font-semibold mb-4">Transações ({selectedPerson?.transactions?.length || 0})</h3>
                            
                            {selectedPerson?.transactions && selectedPerson.transactions.length > 0 ? (
                                <div className="overflow-x-auto">
                                    <table className="min-w-full divide-y divide-gray-200">
                                        <thead className="bg-gray-50">
                                            <tr>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    ID da Transação
                                                </th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    Status
                                                </th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    Valor
                                                </th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    Data
                                                </th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    Tipo
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className="bg-white divide-y divide-gray-200">
                                            {selectedPerson.transactions.map((transaction, index) => (
                                                <tr key={transaction.id || index} className="hover:bg-gray-50">
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                        {transaction.id || `#${index + 1}`}
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap">
                                                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                                                            transaction.status === 'succeeded' 
                                                                ? 'bg-green-100 text-green-800'
                                                                : transaction.status === 'pending'
                                                                ? 'bg-yellow-100 text-yellow-800'
                                                                : 'bg-red-100 text-red-800'
                                                        }`}>
                                                            {transaction.status === 'succeeded' ? 'Aprovado' :
                                                             transaction.status === 'pending' ? 'Pendente' :
                                                             transaction.status === 'failed' ? 'Falhou' :
                                                             transaction.status || 'Desconhecido'}
                                                        </span>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                        {transaction.amount ? formatCurrency(transaction.amount) : 'N/A'}
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                        {transaction.created ? formatTransactionDate(transaction.created) : 'N/A'}
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                        {transaction.type || 'Pagamento'}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <div className="text-center py-8 text-gray-500">
                                    Nenhuma transação encontrada para este usuário.
                                </div>
                            )}
                        </div>
                        
                        <div className="flex space-x-2 mt-6">
                            <button 
                                className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline flex-1"
                                onClick={() => {
                                    if (window.confirm('Tem certeza que deseja excluir este administrador?')) {
                                        confirmDeleteUser(selectedPerson?._id);
                                    }
                                }}
                            >
                                Excluir
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}